import service from '../utils/axios'
import store from '../store/index'

export default {
  async request (method, url, params, data, headers = {}, config = {}, isSilent = false, cutomReload = false) {
    const isHandleLoadingListStaffAcast = url.includes('sms/members') || url.includes('sms/areas')
    const isHandleLoadingListMessageAcast = url.includes('sms') && !isHandleLoadingListStaffAcast
    try {
      // if (store.state.common.isCallingApi) return
      if (!isSilent) {
        if (!isHandleLoadingListMessageAcast && !isHandleLoadingListStaffAcast) {
          store.commit('common/SET_IS_CALLING_API', true)
        }
        if (isHandleLoadingListStaffAcast) store.commit('common/SET_IS_CALLING_LIST_STAFF_ACAST_API', true)
        if (isHandleLoadingListMessageAcast) store.commit('common/SET_IS_CALLING_LIST_MESSAGE_ACAST_API', true)
      }
      const result = await service.request({ ...config, url, params, data, method: method.toLowerCase(), headers })
      if (cutomReload) {
        if (!isHandleLoadingListMessageAcast && !isHandleLoadingListStaffAcast) {
          store.commit('common/SET_IS_CALLING_API', true)
        }
        if (isHandleLoadingListStaffAcast) store.commit('common/SET_IS_CALLING_LIST_STAFF_ACAST_API', true)
        if (isHandleLoadingListMessageAcast) store.commit('common/SET_IS_CALLING_LIST_MESSAGE_ACAST_API', true)
      } else {
        store.commit('common/SET_IS_CALLING_API', false)
        if (isHandleLoadingListStaffAcast) store.commit('common/SET_IS_CALLING_LIST_STAFF_ACAST_API', false)
        if (isHandleLoadingListMessageAcast) store.commit('common/SET_IS_CALLING_LIST_MESSAGE_ACAST_API', false)
      }
      return result
    } catch (e) {
      store.commit('common/SET_IS_CALLING_API', false)
      if (isHandleLoadingListStaffAcast) store.commit('common/SET_IS_CALLING_LIST_STAFF_ACAST_API', false)
      if (isHandleLoadingListMessageAcast) store.commit('common/SET_IS_CALLING_LIST_MESSAGE_ACAST_API', false)
      throw e
    }
  },

  getCTI (url, params, config = {}, isSilent = true) {
    return this.request('get', url, params, {}, {}, config, isSilent)
  },

  get (url, params, config = {}, isSilent = true) {
    return this.request('get', url, params, {}, {}, config, isSilent)
  },

  post (url, data, headers = {}, config = {}, isSilent = false, cutomReload = false) {
    return this.request('post', url, {}, data, headers, config, isSilent, cutomReload)
  },

  put (url, data, config = {}, isSilent = false) {
    return this.request('put', url, {}, data, {}, config, isSilent)
  },

  patch (url, data, config = {}, isSilent = false) {
    return this.request('patch', url, {}, data, {}, config, isSilent)
  },

  delete (url, data = {}, config = {}) {
    return this.request('delete', url, {}, data, {}, config)
  }
}
